import { Check } from 'lucide-react';
import { cn } from '../lib/utils.js';

/**
 * Horizontal status stepper (vertical on small screens). Steps only display API state.
 * @param {{ steps: Array<{ id: string, label: string, done: boolean, hint?: import('react').ReactNode }>, current?: string|null, label: string, className?: string }} props
 */
export function Stepper({ steps, current, label, className }) {
  return (
    <ol aria-label={label} className={cn('flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-0', className)}>
      {steps.map((step, index) => {
        const isCurrent = step.id === current;
        return (
          <li
            key={step.id}
            aria-current={isCurrent ? 'step' : undefined}
            data-state={step.done ? 'done' : isCurrent ? 'current' : 'open'}
            className="flex items-center gap-2 sm:flex-1 sm:flex-col sm:items-center sm:gap-1 sm:text-center"
          >
            <div className="flex items-center sm:w-full">
              <span className={cn('hidden h-px flex-1 sm:block', index === 0 ? 'invisible' : step.done ? 'bg-primary' : 'bg-border')} />
              <span
                className={cn(
                  'flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-semibold',
                  step.done && 'border-primary bg-primary text-primary-foreground',
                  !step.done && isCurrent && 'border-primary text-primary',
                  !step.done && !isCurrent && 'text-muted-foreground',
                )}
              >
                {step.done ? <Check className="size-4" aria-hidden="true" /> : index + 1}
              </span>
              <span
                className={cn('hidden h-px flex-1 sm:block', index === steps.length - 1 ? 'invisible' : steps[index + 1]?.done ? 'bg-primary' : 'bg-border')}
              />
            </div>
            <span className="flex flex-col">
              <span className={cn('text-sm', step.done || isCurrent ? 'font-medium' : 'text-muted-foreground')}>
                {step.label}
                <span className="sr-only">{step.done ? ' (erledigt)' : isCurrent ? ' (aktueller Schritt)' : ' (offen)'}</span>
              </span>
              {step.hint && <span className="text-xs text-muted-foreground">{step.hint}</span>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
